import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { trackPageView } from './lib/analytics.js';
import Layout from './components/Layout.jsx';
import Overview from './pages/Overview.jsx';
import Practice from './pages/Practice.jsx';
import Plan from './pages/Plan.jsx';
import Apply from './pages/Apply.jsx';
import Medi from './pages/Medi.jsx';
import ReadingLab from './pages/ReadingLab.jsx';
import DrillChunk from './pages/DrillChunk.jsx';
import Parents from './pages/Parents.jsx';
import Teachers from './pages/Teachers.jsx';
import About from './pages/About.jsx';
import ForSchools from './pages/ForSchools.jsx';
import Ucatsen from './pages/Ucatsen.jsx';
import WorkExperience from './pages/WorkExperience.jsx';
import CareerCamp from './pages/CareerCamp.jsx';
import WeQuiz from './pages/WeQuiz.jsx';
import WeFinder from './pages/WeFinder.jsx';
import WeReflection from './pages/WeReflection.jsx';
import ScoreConverter from './pages/ScoreConverter.jsx';
import WhereCanIApply from './pages/WhereCanIApply.jsx';
import PsAnalyzer from './pages/PsAnalyzer.jsx';
import SchoolMatcher from './pages/SchoolMatcher.jsx';
import GradeCheck from './pages/GradeCheck.jsx';
import HotTopics from './pages/HotTopics.jsx';
import TutorMatch from './pages/TutorMatch.jsx';
import StrategyAudit from './pages/StrategyAudit.jsx';
import TutorPortal from './pages/TutorPortal.jsx';
import TutorVennLive from './pages/TutorVennLive.jsx';
import InferenceBuilder from './pages/InferenceBuilder.jsx';
import Timeline from './pages/Timeline.jsx';
import Gamsat from './pages/Gamsat.jsx';
import GamsatEssay from './pages/GamsatEssay.jsx';
import UcatConverter from './pages/UcatConverter.jsx';
import DoctorSalaries from './pages/DoctorSalaries.jsx';
import Calendar from './pages/Calendar.jsx';
import WeMap from './pages/WeMap.jsx';
import UcatVideos from './pages/UcatVideos.jsx';
import VennArchitect from './pages/VennArchitect.jsx';
import MentalArithmetic from './pages/MentalArithmetic.jsx';
import ProbabilityReasoning from './pages/ProbabilityReasoning.jsx';
import ConversionGauntlet from './pages/ConversionGauntlet.jsx';
import DecisionProfiler from './pages/DecisionProfiler.jsx';
import ShapeEquations from './pages/ShapeEquations.jsx';
import Syllogisms from './pages/Syllogisms.jsx';
import NumpadTrainer from './pages/NumpadTrainer.jsx';
import DataProbability from './pages/DataProbability.jsx';
import DrillSubVocal from './pages/DrillSubVocal.jsx';
import DrillMemory from './pages/DrillMemory.jsx';
import NearMiss from './pages/NearMiss.jsx';
import GmcGdcStandards from './pages/GmcGdcStandards.jsx';
import SocialMediaAi from './pages/SocialMediaAi.jsx';
import OutcomesGraduates from './pages/OutcomesGraduates.jsx';
import Signup from './pages/Signup.jsx';
import Login from './pages/Login.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import VerifyEmail from './pages/VerifyEmail.jsx';
import Admin from './pages/Admin.jsx';
import DailyQuestion from './pages/DailyQuestion.jsx';
import TutorReadingLab from './pages/TutorReadingLab.jsx';
import TutorSjtCards from './pages/TutorSjtCards.jsx';
import TutorProbLive from './pages/TutorProbLive.jsx';
import TutorSyllogismBoard from './pages/TutorSyllogismBoard.jsx';
import TutorMockReview from './pages/TutorMockReview.jsx';

function RouteTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);
  return null;
}

export default function App() {
  return (
    <>
    <RouteTracker />
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="practice" element={<Practice />} />
        <Route path="plan" element={<Plan />} />
        <Route path="apply" element={<Apply />} />
        <Route path="medi" element={<Medi />} />

        <Route path="reading-lab" element={<ReadingLab />} />
        <Route path="ucatsen" element={<Ucatsen />} />
        <Route path="work-experience" element={<WorkExperience />} />
        <Route path="career-camp" element={<CareerCamp />} />
        <Route path="we-quiz" element={<WeQuiz />} />
        <Route path="we-finder" element={<WeFinder />} />
        <Route path="we-reflection" element={<WeReflection />} />
        <Route path="timeline" element={<Timeline />} />
        <Route path="gamsat" element={<Gamsat />} />
        <Route path="gamsat-essay" element={<GamsatEssay />} />
        <Route path="score-converter" element={<ScoreConverter />} />
        <Route path="where-can-i-apply" element={<WhereCanIApply />} />
        <Route path="ps-analyser" element={<PsAnalyzer />} />
        <Route path="school-matcher" element={<SchoolMatcher />} />
        <Route path="grade-check" element={<GradeCheck />} />
        <Route path="hot-topics" element={<HotTopics />} />
        <Route path="tutor-match" element={<TutorMatch />} />
        <Route path="strategy-audit" element={<StrategyAudit />} />
        <Route path="about" element={<About />} />
        <Route path="ucat-converter" element={<UcatConverter />} />
        <Route path="doctor-salaries" element={<DoctorSalaries />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="we-map" element={<WeMap />} />
        <Route path="videos" element={<UcatVideos />} />
      </Route>
      <Route path="signup" element={<Signup />} />
      <Route path="login" element={<Login />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="verify-email" element={<VerifyEmail />} />
      <Route path="admin" element={<Admin />} />
      <Route path="parents" element={<Parents />} />
      <Route path="teachers" element={<Teachers />} />
      <Route path="for-schools" element={<ForSchools />} />
      <Route path="drill/chunk" element={<DrillChunk />} />
      <Route path="drill/sub-vocal" element={<DrillSubVocal />} />
      <Route path="drill/memory-trainer" element={<DrillMemory />} />
      <Route path="drill/inference" element={<InferenceBuilder />} />
      <Route path="drill/venn" element={<VennArchitect />} />
      <Route path="drill/mental" element={<MentalArithmetic />} />
      <Route path="drill/probability" element={<ProbabilityReasoning />} />
      <Route path="drill/conversion" element={<ConversionGauntlet />} />
      <Route path="drill/sjt-profiler" element={<DecisionProfiler />} />
      <Route path="drill/shape" element={<ShapeEquations />} />
      <Route path="drill/syllogisms" element={<Syllogisms />} />
      <Route path="drill/numpad" element={<NumpadTrainer />} />
      <Route path="drill/data-prob" element={<DataProbability />} />
      <Route path="drill/sjt-near-miss" element={<NearMiss />} />
      <Route path="drill/sjt-standards" element={<GmcGdcStandards />} />
      <Route path="drill/sjt-social-ai" element={<SocialMediaAi />} />
      <Route path="drill/sjt-outcomes" element={<OutcomesGraduates />} />
      <Route path="drill/daily-question" element={<DailyQuestion />} />
      <Route path="tutor-portal/reading-lab-live" element={<TutorReadingLab />} />
      <Route path="tutor-portal/sjt-cards" element={<TutorSjtCards />} />
      <Route path="tutor-portal/prob-live" element={<TutorProbLive />} />
      <Route path="tutor-portal/syllogism-board" element={<TutorSyllogismBoard />} />
      <Route path="tutor-portal/mock-review" element={<TutorMockReview />} />
      <Route path="tutor-portal" element={<TutorPortal />} />
      <Route path="tutor-portal/venn-live" element={<TutorVennLive />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
